import { render } from "./ReviewAndPayStep.vue?vue&type=template&id=3b0ca520&scoped=true"
import script from "./ReviewAndPayStep.vue?vue&type=script&lang=ts"
export * from "./ReviewAndPayStep.vue?vue&type=script&lang=ts"

import "./ReviewAndPayStep.vue?vue&type=style&index=0&id=3b0ca520&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3b0ca520"

export default script